import React from 'react'
import { colors } from '../themes/colors'
import { Box } from '@mui/material'
import Typography from './Typography'
import { styled } from '@mui/system'

export interface BannerProps {
  symbol: string
  title: string | React.ReactNode
  body: string | React.ReactNode
  testId?: string
  sx?: React.CSSProperties
}

const Container = styled(Box)`
  display: flex;
  flex-direction: row;
  flex-shrink: 1;
  padding: 0.5rem 1rem;
  gap: 1rem;
`

const Icon = styled('span')<{ color: keyof typeof colors }>`
  color: ${({ color }) => colors[color]};
`
export const Banner: React.FC<BannerProps> = ({ body, title, symbol, testId, sx }) => {
  return (
    <Container sx={sx} bgcolor={colors.primary100} data-testid={testId}>
      <Box display='flex' alignItems='center' justifyContent={'center'}>
        <Icon className='material-symbols-outlined' color={'primary500'}>
          {symbol}
        </Icon>
      </Box>

      <Box>
        {typeof title === 'object' && title}
        {typeof title === 'string' && (
          <Typography variant='body2' fontWeight={700} color={'primary700'}>
            {title}
          </Typography>
        )}
        {typeof body === 'object' && body}
        {typeof body === 'string' && (
          <Typography variant='body2' color={'primary500'}>
            {body}
          </Typography>
        )}
      </Box>
    </Container>
  )
}
